/** 从 collection API 行解析 slug（小写） */
export function resolveCollectionSlug(row) {
  return String(row?.slug ?? row?.eventSlug ?? row?.gammaSlug ?? '')
    .trim()
    .toLowerCase();
}
